import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React from "react";
import { PageViewTracker } from "./features/PageViewTracker";
import { useTitle } from "./hooks/useTitle";

const InitialAssessmentForm = React.lazy(
  () => import("./features/initial-assessment")
);
const PatientContactForm = React.lazy(
  () => import("./features/contact/patient-contact")
);
const ProviderContactForm = React.lazy(
  () => import("./features/contact/provider-bhi")
);
const ProviderReferralForm = React.lazy(
  () => import("./features/contact/provider-referral")
);
const PatientCostEstimateForm = React.lazy(
  () => import("./features/contact/cost-estimate")
);
const ProgramEnrollmentForm = React.lazy(
  () => import("./features/contact/program-enroll")
);

const titleRules = [
  { pattern: "/", title: () => "New Patient Intake" },
  { pattern: "/assessment/initial", title: () => "New Patient Intake" },
  { pattern: "/patients/contact-us", title: () => "New Lead" },
  { pattern: "/patients/cost-estimate", title: () => "Cost Estimate" },
  { pattern: "/providers/refer-a-patient", title: () => "Referral" },
  { pattern: "/providers/wellness-integration", title: () => "Collaboration" },
  { pattern: "/program/enroll", title: () => "Program Enrollment" },
];

function TitleController() {
  useTitle(titleRules, "New Patient Intake");
  return null;
}

function App() {
  return (
    <Router>
      <TitleController />
      <PageViewTracker />
      <Routes>
        <Route path="assessment/initial" element={<InitialAssessmentForm />} />

        {/* <Route path=":contact/upload/:key" element={<UploadDocuments />} /> */}

        <Route path="patients/contact-us" element={<PatientContactForm />} />
        <Route
          path="patients/cost-estimate"
          element={<PatientCostEstimateForm />}
        />
        <Route
          path="providers/refer-a-patient"
          element={<ProviderReferralForm />}
        />
        <Route
          path="providers/wellness-integration"
          element={<ProviderContactForm />}
        />

        <Route path="program/enroll" element={<ProgramEnrollmentForm />} />

        <Route path="*" element={<InitialAssessmentForm />} />
      </Routes>
    </Router>
  );
}

export default App;
